// extracted by mini-css-extract-plugin
export default {"toggleIcon":"ExpandCollapseIcon_toggleIcon__cz8ap"};